import React, { Component } from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'

import { FormFileDropzone, FormTextField } from 'components/input/index'
import { withForm } from 'decorators/withForm'
import { campaignBannerEditForm } from 'validators/campaign-banners'

type CampaignBannerEditFormProps = {
  handleSubmit: (...args: any[]) => any
  open: boolean
  title: string
  onClose: (...args: any[]) => any
  onSubmit: (...args: any[]) => any
}

class CampaignBannerEditForm extends Component<CampaignBannerEditFormProps> {
  handleClose = () => this.props.onClose()

  onSubmit = (values: any) => {
    const { onSubmit, onClose } = this.props
    onClose(() => onSubmit(values))
  }

  render() {
    const { handleSubmit, open, title } = this.props

    return (
      <Dialog onClose={this.handleClose} open={open}>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{ width: 500 }}>
              <Grid
                size={{
                  sm: 12,
                }}>
                <FormTextField label="Title" name="title" />
              </Grid>

              <Grid
                size={{
                  sm: 6,
                }}>
                <FormTextField label="Width" name="width" type="number" />
              </Grid>
              <Grid
                size={{
                  sm: 6,
                }}>
                <FormTextField label="Height" name="height" type="number" />
              </Grid>
              <Grid
                size={{
                  sm: 12,
                }}>
                <FormFileDropzone name="file" />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>Close</Button>
            <Button color="primary" type="submit">
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

export default withForm({
  form: 'bannerUpload',
  validate: campaignBannerEditForm,
})(CampaignBannerEditForm)
